import { Link as MuiLink } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import activites from "../../components/utils/Activities";
import { Button } from "../../stories/atoms/Button";
import SanitizeDiv from "../utils/Sanitize";

export const ShowActivity = ({ desc }) => {
    const [currentActivity, setCurrentActivity] = useState(null);
    const [filterProfil, setFilterProfil] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const queryParameters = new URLSearchParams(window.location.search);
    const categorie = queryParameters.get("categorie");

    // 🧠 Initialisation selon la catégorie dans l’URL
    useEffect(() => {
        if (!activites || activites.length === 0) return;

        let profil;
        switch (categorie) {
            case "bebes":
                profil = "bébé";
                break;
            case "enfants":
                profil = "enfant";
                break;
            case "adultes":
                profil = "adulte";
                break;
            case "seniors":
                profil = "sénior";
                break;
            default:
                profil = "bébé";
        }

        // 🧩 On cherche en priorité la catégorie, sinon une activité
        let matchedActivity = activites.find((a) => a.profil === profil && a.isCategory);
        if (!matchedActivity) {
            matchedActivity = activites.find((a) => a.profil === profil && !a.isCategory);
        }

        if (matchedActivity) {
            setFilterProfil(profil);
            setCurrentActivity(matchedActivity);
        }

        setIsLoading(false);
    }, [categorie]);

    const getCategorySlug = (profil) => {
        switch (profil) {
            case "bébé":
                return "bebes";
            case "enfant":
                return "enfants";
            case "adulte":
                return "adultes";
            case "sénior":
                return "seniors";
            default:
                return "bebes";
        }
    };

    // 🎯 Mise à jour au clic sur les onglets
    useEffect(() => {
        if (!filterProfil) return;

        // Cas bébé : on garde la catégorie “bébé” si elle existe, sinon l’activité
        let matched =
            filterProfil === "bébé"
                ? activites.find((a) => a.profil === "bébé" && a.isCategory) || activites.find((a) => a.profil === "bébé" && !a.isCategory)
                : activites.find((a) => a.profil === filterProfil && a.isCategory);

        setCurrentActivity(matched);
    }, [filterProfil]);

    return (
        <section className="vitaleau-section-activity" id="activites">
            <div className="vitaleau-div-activity">
                <Container maxWidth="xl">
                    <Grid container className="vitaleau-activity-grid" justifyContent={"space-between"}>
                        {/* 🟦 Bloc gauche */}
                        {desc && (
                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                <h2 data-title="Nos activités">Nos activités</h2>
                                <p className="mb24">
                                    Pour les petits, pour les grands, pour tous les profils et toutes les envies ! Chez Vital’Eau, nous proposons un
                                    large choix d’activités aquatiques. Que vous cherchiez à entretenir votre forme, à vous dépenser sans prise de
                                    tête ou à dépasser vos limites, il y a forcément une activité faite pour vous !
                                </p>
                            </Grid>
                        )}

                        {/* 🟩 Bloc droit (onglets + cartes) */}
                        <Grid item lg={7} md={7} sm={12} xs={12}>
                            <p>Sélectionnez la catégorie pour afficher les activités qui vous correspondent</p>

                            {/* 🔹 Tabs */}
                            <ul id="accueil-activites-tabs">
                                <li className={filterProfil === "bébé" ? "tabs-active" : ""}>
                                    <MuiLink onClick={() => setFilterProfil("bébé")}>Bébés</MuiLink>
                                </li>
                                <li className={filterProfil === "enfant" ? "tabs-active" : ""}>
                                    <MuiLink onClick={() => setFilterProfil("enfant")}>Enfants</MuiLink>
                                </li>
                                <li className={filterProfil === "adulte" ? "tabs-active" : ""}>
                                    <MuiLink onClick={() => setFilterProfil("adulte")}>Adultes</MuiLink>
                                </li>
                                <li className={filterProfil === "sénior" ? "tabs-active" : ""}>
                                    <MuiLink onClick={() => setFilterProfil("sénior")}>Seniors</MuiLink>
                                </li>
                            </ul>

                            {/* 🔸 Liste des activités correspondantes (sans les catégories) */}
                            <div id="accueil-activites-tabs-contenu">
                                <ul>
                                    {activites
                                        .filter((a) => a.profil === filterProfil && !a.isCategory) // 👈 on exclut les catégories
                                        .map((activite) => (
                                            <li key={activite.titre}>
                                                <Link
                                                    to={
                                                        filterProfil === "bébé"
                                                            ? `/activites/${Array.isArray(activite.slug) ? activite.slug[0] : activite.slug}`
                                                            : `/activites/${getCategorySlug(filterProfil)}/${
                                                                  Array.isArray(activite.slug) ? activite.slug[0] : activite.slug
                                                              }`
                                                    }
                                                    style={{
                                                        marginRight: "5px",
                                                        color: "black",
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    <div className="card_activity_tabs-contenu">
                                                        {activite.iconGradient}
                                                        {activite.titre}
                                                        <br />
                                                        {activite.age}
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </Grid>
                    </Grid>
                </Container>

                {/* 🟣 Bloc affichage principal (catégorie ou activité) */}
                <Grid container>
                    <Grid item xs={12}>
                        <div className="vitaleau-swpier-activity-container">
                            {isLoading ? (
                                <p style={{ textAlign: "center", opacity: 0.5 }}>Chargement...</p>
                            ) : currentActivity ? (
                                <div className="vitaleau-image-container" style={{ transition: "opacity 0.4s ease-in-out" }}>
                                    <div className="vitaleau-img-principal">
                                        <img src={currentActivity.src} alt={currentActivity.titre} title={currentActivity.titre} loading="lazy" />
                                        <div className="icon-activity">{currentActivity.icon}</div>
                                    </div>

                                    <div className="vitaleau-resume-activity">
                                        <h3>{currentActivity.titre}</h3>

                                        {currentActivity.isCategory ? (
                                            <>
                                                <p>{currentActivity.introtext}</p>
                                                <Button
                                                    label="Voir les activités"
                                                    style={{ width: "fit-content", marginTop: "24px" }}
                                                    primary
                                                    href={
                                                        currentActivity.redirectToActivity
                                                            ? `/activites/bebes-nageurs` // 🍼 redirection spéciale
                                                            : `/activites/${currentActivity.slug}`
                                                    }
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <SanitizeDiv content={currentActivity.resume} className="container-info-activite-texte" />
                                                <Button
                                                    label="Découvrir l'activité"
                                                    style={{ width: "fit-content", marginTop: "24px" }}
                                                    primary
                                                    href={`/activites/${currentActivity.slug}`}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <p style={{ textAlign: "center" }}>Aucune activité trouvée.</p>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </div>
        </section>
    );
};
